import { render, staticRenderFns } from "./OnboardingQuestionHowFoundOut.vue?vue&type=template&id=04daa4f0"
import script from "./OnboardingQuestionHowFoundOut.vue?vue&type=script&lang=js"
export * from "./OnboardingQuestionHowFoundOut.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports